import injector from 'vue-inject'
import axios from 'axios'
import { store } from '@/store'

const MAX_REQUESTS_COUNT = 2
const INTERVAL_MS = 200
let PENDING_REQUESTS = 0

//Used interceptors to queuing request
axios.interceptors.request.use(async config => {
  if (!config.url.includes('/signin')) {
    if (!store.getters['auth/isAuthenticated']) {
      await store.dispatch('auth/refreshAccessTokens')
    }
    config.headers['Authorization'] = `Bearer ${store.getters['auth/apiAccessToken']}`
  }

  return new Promise(resolve => {
    let interval = setInterval(() => {
      if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
        PENDING_REQUESTS++
        clearInterval(interval)
        resolve(config)
      }
    }, INTERVAL_MS)
  })
})

axios.interceptors.response.use(
  response => {
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.resolve(response)
  },
  error => {
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.reject(error)
  },
)

/**
 * Api root according to the used environment
 */
injector.constant(
  'apiRoot',
  process.env.NODE_ENV == 'production'
    ? 'https://api.histoverydata.com'
    : process.env.NODE_ENV == 'test'
    ? 'https://api-preprod.histoverydata.com'
    : 'http://localhost:3000',
)

/**
 * Axios library used to make all API requests
 */
injector.constant('axios', axios)
